import React from 'react';

import { useQuery } from '@sopranodesign/pulse-hooks';
import {
  PageWrapper,
  Placeholder,
  Flex,
  NoSubcriberGraphic,
  Heading3
} from '@sopranodesign/pulse-components';
import {
  Comments,
  SubscriberDetails,
  DetailsPanel,
  MainSection,
  NoSubscriber
} from '@sopranodesign/pulse-tickets';

import { LogContent } from '../Components/index';

const Log = ({ match }) => {
  const query = useQuery({
    queryKey: [`logs/${match.params.id}`]
  });

  return (
    <Flex>
      <MainSection>
        <PageWrapper header="Log Details">
          <Flex col ySpace>
            <LogContent log={query.data?.data} />
            <Comments query={`logs/${match.params.id}/comments`} />
          </Flex>
        </PageWrapper>
      </MainSection>
      <DetailsPanel divider header="Subscriber Details">
        {query.isLoading && <Placeholder ySpace />}
        {!query.isLoading && query.data?.data?.subscriber && (
          <SubscriberDetails subscriber={query.data.data.subscriber} />
        )}
        {!query.isLoading && !query.data?.data?.subscriber && (
          <NoSubscriber col center ySpace middle>
            <NoSubcriberGraphic />
            <Heading3>No Subscriber attached to this log</Heading3>
          </NoSubscriber>
        )}
      </DetailsPanel>
    </Flex>
  );
};

export default Log;
